import * as Api from "@modules/api";
import { setAlert, useAppDispatch, useAppSelector } from "@lib/stores";
import { db } from "@modules/local/db";
import { useAppLiveQuery } from "@modules/local/hooks";
import { useAppNavigate } from "@utils/hooks/useAppNavigate";
import { UseComponentDataArgs } from "@modules/content/hooks/useComponentData";
import {
  ContentComponent,
  ContentComponentRefType,
} from "@modules/content/types";
import { detailsPageType } from "@utils/helpers/detailsPageType";
import { setStorage } from "@modules/storage/storageHelper";
import { AlertType } from "@lib/stores/common/types";
import { translate } from "@modules/localizations/translate";

import { FeaturedContentComponent } from "./FeaturedContentComponent";
import { HorizontalListComponent } from "./HorizontalListComponent";
import { ListsContainerComponent } from "./ListsContainerComponent";
import { CircleListComponent } from "./CircleListComponent";
import { MappedHorizontalListComponent } from "./MappedHorizontalListComponent";
import { CollectionListComponent } from "./CollectionListComponent";
import { CollectionListsContainerComponent } from "./CollectionListsContainerComponent";
import { WelcomeCardComponent } from "./WelcomeCardComponent";
import { SkillCardListComponent } from "./SkillCardListComponent";
import { MySkillCardListComponent } from "./MySkillCardListComponent";
import { SkillContentVerticalListComponent } from "./SkillContentVerticalListComponent";
import { useContentSelector } from "../hooks/useContentSelector";
import { MyCertificatesComponent } from "./MyCertificatesComponent";
import { RamadanContentComponent } from "./RamadanContentComponent";
import { FeaturedContentComponentV3 } from "./FeaturedContentComponentV3";
import { LiveAyahContentComponent } from "./LiveAyahContentComponent";
import { OtherAyatListComponent } from "./OtherAyatListComponent";
import { RamadanContentListComponent } from "./RamadanContentListComponent";
import { RepeatedJuzuListComponent } from "./RepeatedJuzuListComponent";
import { TitledHorizentalListComponent } from "./TitledHorizentalListComponent";
import { VerticalListComponent } from "./VerticalListComponent";
import { RepeatedPrayerTypesGridComponent } from "./RepeatedPrayerTypesGridComponent";
import { RepeatedPrayerListComponent } from "./RepeatedPrayerListComponent";

export const components: ContentComponent[] = [
  FeaturedContentComponent,
  HorizontalListComponent,
  ListsContainerComponent,
  MappedHorizontalListComponent,
  CircleListComponent,
  CollectionListsContainerComponent,
  CollectionListComponent,
  WelcomeCardComponent,
  SkillCardListComponent,
  MySkillCardListComponent,
  SkillContentVerticalListComponent,
  MyCertificatesComponent,
  RamadanContentComponent,
  FeaturedContentComponentV3,
  LiveAyahContentComponent,
  OtherAyatListComponent,
  RamadanContentListComponent,
  RepeatedJuzuListComponent,
  TitledHorizentalListComponent,
  VerticalListComponent,
  RepeatedPrayerTypesGridComponent,
  RepeatedPrayerListComponent,
];

console.log("components", components);
console.log(
  "components",
  components.map((s) => s.identifier)
);

export type ExtraProps = {
  titleClassName?: string;
  selectedContentId?: string;
};

export type ContentComponentSelectorProps = UseComponentDataArgs & {
  identifier: string;
  componentRef: React.Ref<ContentComponentRefType>;
  className?: string;
  extraProps?: ExtraProps;
};

const ContentComponentSelector = ({
  className,
  ...props
}: ContentComponentSelectorProps) => {
  const navigate = useAppNavigate();

  const userId = useAppSelector((state) => state.auth.user.id ?? "");

  const { result: flow } = useAppLiveQuery(
    () => db.readerFlows.get(userId),
    [userId]
  );

  const element = components.find((c) => c.identifier === props.identifier);

  const { onSelectContent } = useContentSelector();

  if (!element) {
    console.log(
      "ContentComponentSelector",
      "element not found",
      props.identifier
    );
    return null;
  }

  return (
    <element.component
      {...props}
      ref={props.componentRef}
      className={className}
      onItemPress={
        props.onItemPress
          ? props.onItemPress
          : async (content, item, extra) => {
              onSelectContent(content, item, {
                narratorId: extra.narratorId,
                isLocked: extra.isLocked,
              });
            }
      }
    />
  );
};

export default ContentComponentSelector;
